import styled from 'styled-components';

export const BaseCellContent = styled.span`
  display: grid;
  column-gap: var(--spacing-md);
  grid-template-columns: max-content 1fr;
  justify-self: center;
  align-self: center;
`;

export const TextOnly = styled(BaseCellContent)`
  grid-template-columns: unset;
  width: 100%;
  align-self: start;
`;

export const IconOnly = styled(BaseCellContent)`
  grid-template-columns: min-content;
`;
